import React, { Suspense, lazy } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './styles/base.css';
import './styles/buttons.css';
import RouteChrome from './components/RouteChrome';
import { ROUTES } from './routes';

// Each page is its own chunk. The scroll-end "next page" transition
// prefetches the upcoming chunk at 40% progress (see useNextPage).
const HomePage = lazy(ROUTES.home.load);
const CardPage = lazy(ROUTES.card.load);
const AboutPage = lazy(ROUTES.about.load);

export default function SiteApp() {
  return (
    <BrowserRouter>
      <RouteChrome />
      <Suspense fallback={null}>
        <Routes>
          <Route path={ROUTES.card.path} element={<CardPage />} />
          <Route path={ROUTES.about.path} element={<AboutPage />} />
          <Route path="*" element={<HomePage />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}
